export default {
  visible: false,
  length: 50,
  height: 100,
  width: 20,
};
